import { instance, simpleInstance } from '@/api/instances'
import { ERRORS } from '@/models/accredited-network'

const searchAddress = async (store, { query, sessionId }) => {
  try {
    const data = await instance.get('/maps/address/search', {
      params: {
        q: query
      },
      headers: {
        'Session-Id': sessionId
      }
    })
    return data
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'accreditedNetwork/searchAddress' },
      { root: true }
    )

    return []
  }
}

const getLocationByPlaceId = async (store, placeId) => {
  try {
    const data = await instance.get(`/maps/address/${placeId}`)
    return [false, data]
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'accreditedNetwork/getLocationByPlaceId' },
      { root: true }
    )

    return [true, null]
  }
}

const getMemberInfo = async (store, { personId }) => {
  try {
    const data = await instance.get(`/member-hub/persons/${personId}`)

    return [false, data]
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'accreditedNetwork/getMemberInfo' },
      { root: true }
    )

    return [true, null]
  }
}

const getMemberPhotoURL = async (store, url) => {
  if (!url) return

  try {
    const response = await simpleInstance.get(url)
    return response
  } catch (error) {
    store.commit(
      'errors/setError',
      'Não foi possível recuperar a foto de perfil do membro',
      { root: true }
    )
  }
}

const getProvidersByLocation = async (
  store,
  {
    personId,
    specialty,
    filterType,
    ageGroup,
    lat,
    lng,
    rangeInMeters = 10000
  } = {}
) => {
  try {
    const providers = await instance.get(
      `persons/${personId}/accredited-network/`,
      {
        params: {
          lat,
          lng,
          rangeInMeters,
          filterType,
          ageGroup,
          specialty
        }
      }
    )

    return [false, providers]
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'accreditedNetwork/getProvidersByLocation' },
      { root: true }
    )

    return [true, null]
  }
}

const getProviderDetailsById = async (store, { personId, type, id }) => {
  try {
    const details = await instance.get(
      `/persons/${personId}/accredited-network/${type}/${id}`
    )

    return [false, details]
  } catch (error) {
    if (error?.response?.data.code !== ERRORS.MISSING_CASSI_MEMBERSHIP) {
      store.dispatch(
        'errors/setError',
        { error, request: 'accreditedNetwork/getProviderDetailsById' },
        { root: true }
      )
    }

    return [true, error?.response]
  }
}

const getFiltersByAgeGroup = async store => {
  try {
    const options = await instance.get('accredited-network/filters/age_group')
    return [false, options]
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'accreditedNetwork/getFiltersByAgeGroup' },
      { root: true }
    )

    return [true, []]
  }
}

const getFiltersByType = async store => {
  try {
    const options = await instance.get('accredited-network/filters/type')
    return [false, options]
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'accreditedNetwork/getFiltersByType' },
      { root: true }
    )

    return [true, []]
  }
}

const getFiltersBySpecialty = async store => {
  try {
    const options = await instance.get('accredited-network/filters/specialty')
    return [false, options]
  } catch (error) {
    store.dispatch(
      'errors/setError',
      { error, request: 'accreditedNetwork/getFiltersBySpecialty' },
      { root: true }
    )

    return [true, []]
  }
}

const setSessionId = (store, sessionId) => {
  store.commit('setSessionId', sessionId)
}

export default {
  searchAddress,
  getLocationByPlaceId,
  getMemberInfo,
  getMemberPhotoURL,
  getProvidersByLocation,
  getProviderDetailsById,
  getFiltersByAgeGroup,
  getFiltersByType,
  getFiltersBySpecialty,
  setSessionId
}
